import { createAppLogging } from '@ahaslides-product/frontend-toolkit'
import Config from '@/config'
import Sentry, { getTraceId } from '@/3rd-parties/sentry'

const _getters = {
  canTrackSlideIdForPostReqs: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('AHA-40581-track-answer-slideid')
  },
}

const plugin = createAppLogging({
  config: Config,
  service: 'audience',
  flag: 'AHA-35479-setup-logging-lib',
  // Set of vuex actions to ignore in logging
  ignoredActions: [
    'systemConnection/setEmqxConnection',
    'systemConnection/setSocketConnection',
    'websocket/newMessage',
    'kvSync/updateKeyValueAction',
  ],
  slideActions: [
    'setSlide',
    'updateSlide',
    'nextback/changeSlideAction',
  ],
  contextMutations: {
    setAudienceId: (audienceId) => ({ audienceId }),
    setPresentation: (presentation) => ({ presentationId: presentation.id }),
    setCurrentUser: (user) => ({ userId: user.id }),
  },
  getTraceId,
  captureException: Sentry.captureException,
})

export default {
  namespaced: true,
  getters: _getters,
  plugin,
}
